import { render } from "./UpdateInfos.vue?vue&type=template&id=1fca2a94&scoped=true&ts=true"
import script from "./UpdateInfos.vue?vue&type=script&lang=ts"
export * from "./UpdateInfos.vue?vue&type=script&lang=ts"

import "./UpdateInfos.vue?vue&type=style&index=0&id=1fca2a94&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fca2a94"]])

export default __exports__